import { useCurrentUser, useAccessToken } from '@/features/auth/state/auth'

import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL
const api = axios.create({ baseURL: BASE_URL })

export function useFetchSimples(id_apuracao: string | undefined | null) {
  const user = useCurrentUser()
  const token = useAccessToken()

  return useQuery({
    queryKey: ['simples', id_apuracao],
    queryFn: async () => {
      if (!user || !token) throw new Error('Usuário ou token ausente')

      const response = await api.get(`/simples/${id_apuracao}/competencias`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data?.data) {
        return response.data.data 
      } else {
        throw new Error('Estrutura de resposta inesperada')
      }
    },
    enabled: Boolean(user && token)
  })
}
